import React from 'react'
import Helmet from 'react-helmet'

const host = 'https://www.reddigitalchina.com'

export default ({metaData, tag}) => (
    tag? 
    <Helmet>
        <html lang="en"/>
        <title>Read our chinese digtal marketing trend, insights and {tag} | Red Digital China</title>
        <meta name="description" content={`Here is everything you need to know about Chinese digital marketing, latest insights, trends and news relating to ${tag}`}/>
        <meta property="og:url" content={`${host}${metaData.siteUrl}`}/>
        <meta property="og:local" content="en_GB"/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content={`Read our chinese digtal marketing trend, insights and ${tag}`}/>
        <meta property="og:description" content={`Here is everything you need to know about Chinese digital marketing, latest insights, trends and news relating to ${tag}`}/>
        <meta property="og:site_name" content="Red Digital China: Chinese digital agency"/>
        <meta property="og:image" content={`${host}${metaData.imageUrl}`}/>   
        <script id="Cookiebot" src="https://consent.cookiebot.com/uc.js" data-cbid="79580515-4c86-4e39-aa84-3d661091d2e0" type="text/javascript" async/>
    </Helmet> : 
    <Helmet>
        <html lang="en"/>
        <title>Red Digital China | {metaData.title}</title>
        <meta name="description" content={metaData.description}/>
        <meta property="og:url" content={`${host}${metaData.siteUrl}`}/>
        <meta property="og:local" content="en_GB"/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content={`Red Digital China | ${metaData.title}`}/>
        <meta property="og:description" content={metaData.description}/>
        <meta property="og:site_name" content="Red Digital China: Chinese digital agency"/>
        <meta property="og:image" content={`${host}${metaData.imageUrl}`}/>
        <script
        type="text/javascript"
        src="https://app.termly.io/embed.min.js"
        data-auto-block="on"
        data-website-uuid="a5e9afdf-8af6-4d2f-af5c-98caab7dff48"
        ></script>
    </Helmet>

)